import React, { Component } from 'react';

import LoadingSpinner from '../common/LoadingSpinner.js';

import SitesTreeView from './SitesTreeView.js';
import InfoPane from './InfoPane.js';

class Sites extends Component {

  constructor(props) {
    super(props);
    this.state = {
      availableResources:[],
      selectedSiteInfo: null,
      loading: true
    }
  }

  componentDidMount = () => {
    Promise.all([this.getAvailableSites()])
      .then(() => this.setState({loading: false}));
  }

  getAvailableSites = () => {
    return fetch(
      '/api/getAvailableSites',
      {
        method: "GET",
        credentials: "same-origin",
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then((data) => {
        this.buildState(data);
      })
      .catch((error) => console.log(error));
  }

  buildCurrentNodeFromResource = (node, resource) => {
    node.name = resource.dn[resource.dn.length - 1];
    node.type = resource.type;
    node.onClick = () => this.setState({selectedSiteInfo: node});
    node.notice = resource.notice;
    if (resource.type === "dc") {
      node.url = resource.url;
      node.ldap = resource.ldap;
    } else {
      node.contactName = resource.name;
      node.email = resource.email;
      node.phone = resource.phone;
      node.address = resource.address;
    }
  }

  buildState = (resourceList) => {
    let state = [];
    let tree = {};
    let curNode;
    resourceList.forEach((resource) => {
      let curTree = tree;
      let curState = state;
      resource.dn.forEach((nodeName, i) => {
        if (curTree[nodeName] === undefined) {
          curTree[nodeName] = { index: curState.length, children: {} };
          curState.push({});
        }
        curNode = curState[curTree[nodeName].index];

        if (i !== resource.dn.length - 1) {
          if (curNode.children === undefined) {
            curNode.children = [];
          }
          curState = curNode.children;
          curTree = curTree[nodeName].children;
        } else {
          this.buildCurrentNodeFromResource(curNode, resource);
        }
      })
    })
    this.setState({availableResources: state});
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />
    }

    return(
      <div>
        <h2 className="form-title">Available Sites</h2>
        <div className="form-group">
          <div className="col-md-6">
            <SitesTreeView data={this.state.availableResources} />
          </div>
          <div className="col-md-6">
            <InfoPane data={this.state.selectedSiteInfo} />
          </div>
        </div>
      </div>
    );
  }

}

export default Sites;


// WEBPACK FOOTER //
// ./src/Components/sites/Sites.js